import { componentMapper, attachmentTypes, status, constantStrings, surveyForm } from '@/services/constants'
import store from '../../store'
import AppWarn from '../errors/app-warns'
import Storage from '@/services/storageLib'
const _ = require('lodash')

export function userMessageParser(message) {
  try {
    if (!Object.keys(message).length) return
    let formComponentType, formSubmittedResponse = false;
    const attachments =
      (message?.attachmentList?.length &&
        message.attachmentList.map(attachment => {
          if(attachment.type === attachmentTypes.MessageInfoAttachment) {
            if (attachment?.values['isSchemaForm']) {
              if (_.isEqual(attachment.values['status'], ["SUBMITTED"]) && attachment?.values['schemaFormRequestId'] ) {
              formSubmittedResponse = true
              const submissionObject = {};
              submissionObject[attachment.values['schemaFormRequestId']] = message?.messagePayload?.text;
              store.state.formsSubmittedInfo = {...store.state.formsSubmittedInfo, ...submissionObject}
              }
              else if (_.isEqual(attachment.values['status'], ["SKIPPED"]) && attachment?.values['schemaFormRequestId']) {
              const formSkipObject = {};
              formSkipObject[attachment.values['schemaFormRequestId']] = message?.messagePayload?.text;
              store.state.formSkipInfo = {...store.state.formSkipInfo, ...formSkipObject}
              }
               formComponentType = componentMapper[attachment.type][2]
            } else if (attachment?.values['isLLMSchemaForm']) {
              if (_.isEqual(attachment.values['status'], ["SUBMITTED"]) && attachment?.values['schemaFormRequestId'] ) {
                formSubmittedResponse = true
                const submissionObject = {};
                submissionObject[attachment.values['schemaFormRequestId']] = message?.messagePayload?.label;
                store.state.formsSubmittedInfo = {...store.state.formsSubmittedInfo, ...submissionObject}
              }
               formComponentType = componentMapper[attachment.type][4]
            }
            else if(attachment?.values['isEmbeddedForm']) {
              formComponentType = componentMapper[attachment.type][1]
            } else if( attachment?.values['status']) {
              formComponentType = componentMapper[attachment.type][0]
            } 
          }
           return {
            messageId: message.messagePayload.messageId,
            type: componentMapper[attachment.type][0],
            actualType:
              attachment.actualType &&
              componentMapper[attachment.actualType][0],
            hide: formComponentType ? 
                formComponentType === 'HumanHandoffForm' &&
                attachment?.values['status'][0] === status.REJECTED
              : false,
            messageValue: { ...attachment },
            timestamp: parseInt(message.messagePayload.timestamp),
            isUser: true,
            requestId: message.requestId
          }
        })) ||
      []
    if (formSubmittedResponse) {
      message.hide = true
    }
    const userMessage = checkIfMessageValid(message) && [ userMessagePayload(message) ] || []
    let messages = []
    if (attachments?.length && !['EmbeddedForm', 'SchemaForm', 'LLMSchemaForm'].includes(formComponentType)) {
      messages = [...attachments]
    } else if (userMessage?.length && attachments?.length && formComponentType === 'EmbeddedForm') {
      userMessage[0].messageValue["status"] = attachments[0]?.messageValue?.values?.status[0]
      userMessage[0].messageValue["iframeHeightWithOnlyQuestions"] = attachments[0]?.messageValue?.values?.iframeHeightWithOnlyQuestions[0]
      messages = [...userMessage]
    } else if (formComponentType === 'LLMSchemaForm') {
      message.messagePayload.isLLMSchemaForm = true
      const userMessage = checkIfLLMSchemaFormMessageValid(message) && [ userMessagePayload(message) ] || []
      messages = [...userMessage]
    } else if (userMessage?.length){
      messages = [...userMessage]
    }
    return messages.length
      ? {
          isUser: true,
          tabId: Storage.getSessionStorageData('tabId'),
          messages,
          requestId: message.requestId,
          timestamp: parseInt(message.messagePayload.timestamp)
        }
      : []
  } catch (err) {
    console.log(err.message)
    throw new AppWarn({name: 'UserMessageParser', message:`Error while parsing user message. ${err.message}`})
  }
}

function checkIfMessageLabelValid(message) {
  return (message.messagePayload.label !== constantStrings.PROACTIVE_GREETING_LABEL || 
        (
          !store.state.widgetConfig?.proActiveGreetings?.includes(message.messagePayload.text) &&
          !store.state.widgetConfig?.sessionRestartGreeting?.includes(message.messagePayload.text) && 
          store.state.widgetConfig?.endChat?.endChatGreeting != message.messagePayload.text
        )) && message?.messagePayload?.label !== constantStrings.CALLOUT_BUBBLE_TEXT &&
        !message.messagePayload.hideMessage
}

function checkIfMessageValid(message) {
  const formControlActions = ['event://;BACK_EVENT;','event://;RESTART_WORKFLOW_EVENT;', 'event://;SKIP_EVENT;', 'event://;SKIP_EVENT;resumeWorkflow=false']
  return (message.messagePayload.text && (
    !checkIsSurveySkipped(message.messagePayload.text, formControlActions)
  ) && checkIfMessageLabelValid(message) && !isFormSubmittedInValid(message.messagePayload))
}

function isFormSubmittedInValid({ text, label }) {
  return (
    text?.startsWith(constantStrings.EVENT_LEARN_ATTRIBUTE) && !label
  )
}

function checkIsSurveySkipped(text, formControlActions) {
  return (
    formControlActions.includes(text) || text.includes(surveyForm.SKIP_EVENT)
  )
}

function checkIfLLMSchemaFormMessageValid(message) {
  const formControlActions = ['event://;BACK_EVENT;','event://;RESTART_WORKFLOW_EVENT;', 'event://;SKIP_EVENT;', 'event://;SKIP_EVENT;resumeWorkflow=false']
  return (message.messagePayload.text && (
    !checkIsSurveySkipped(message.messagePayload.text, formControlActions)
  ) && checkIfMessageLabelValid(message))
}

const userMessagePayload = (message) => {
  return {
    messageId: message.messagePayload.messageId,
    type: componentMapper['ai.msg.domain.responses.core.Text'][0],
    messageValue: {
      text: message.messagePayload.text,
      label: message.messagePayload.label,
      ...(message.messagePayload.isLLMSchemaForm && {isLLMSchemaForm: true}),
    },
    timestamp: parseInt(message.messagePayload.timestamp),
    isUser: true,
    hide: message.hide,
    status: store.state.connectionStatus ? constantStrings.SENT : constantStrings.FAILED
  }
}
